import { Link } from 'react-router-dom';

import { Pill } from '@nearst/ui';
import { ImageField } from './ImageField';

import styles from './StockLevels.module.scss';

const formatFieldValue = (item, fieldName) => {
	const value = item[fieldName];

	if (value === undefined || value === null) {
		return 'Not set';
	}

	if (fieldName === 'price') {
		return Number(value).toLocaleString('en', { style: 'currency', currency: item.currency || 'GBP' });
	}

	if (fieldName === 'images') {
		return <ImageField value={value} />;
	}

	return String(value);
};

const createFieldSortFn = (fieldName) => ({
	asc: (a, b) => String(a[fieldName] || '').localeCompare(String(b[fieldName] || '')),
	desc: (a, b) => String(b[fieldName] || '').localeCompare(String(a[fieldName] || ''))
});

export const getTableFields = (barcode, fieldName) => {
	const locationField = {
		id: 'location',
		title: 'Location',
		sortFn: {
			asc: (a, b) => a.name.localeCompare(b.name),
			desc: (a, b) => b.name.localeCompare(a.name)
		},
		formatter: (item) => (
			<div className={styles.name}>
				<Link to={`/inventory/${item.shopId}/items/${barcode}`}>{item.name}</Link>
			</div>
		)
	};

	if (fieldName) {
		const capitalizedFieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
		return [
			locationField,
			{
				title: capitalizedFieldName,
				id: fieldName,
				sortFn: createFieldSortFn(fieldName),
				formatter: (item) => formatFieldValue(item, fieldName)
			}
		];
	}

	// Default view with price, quantity, and status
	return [
		locationField,
		{
			title: 'Price',
			id: 'price',
			sortFn: {
				asc: (a, b) => a.price - b.price,
				desc: (a, b) => b.price - a.price
			},
			formatter: (item) => Number(item.price).toLocaleString('en', { style: 'currency', currency: item.currency || 'GBP' })
		},
		{
			title: 'Quantity',
			id: 'quantity',
			sortFn: {
				asc: (a, b) => a.quantity - b.quantity,
				desc: (a, b) => b.quantity - a.quantity
			},
			formatter: (item) => Number(item.quantity).toLocaleString()
		},
		{
			title: 'Status',
			id: 'status',
			sortFn: {
				asc: (a, b) => a.status - b.status,
				desc: (a, b) => b.status - a.status
			},
			formatter: (item) => (item.quantity > 0 ? <Pill>In stock</Pill> : <Pill colour="grey">Out of stock</Pill>)
		}
	];
};
